const marketingUrl = '/Marketing';
const websiteMarketingBaseUrl = '/website/marketing';

export default {
    websiteVisitedUrl: () => `${marketingUrl}/websiteVisited`,
    getMarketingCampaignDataByNameUrl: (campaignName) =>
        `${websiteMarketingBaseUrl}/marketingCampaign/${campaignName}`,
};
